// src/api/http.js
import axios from "axios";

export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8095"; // mets ton URL prod ici
/* export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://api.amenedistribution.tn";
*/
const http = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false, // passe à true seulement si tu utilises un cookie + CORS credentials
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

// 401 = token invalide/expiré → on nettoie la session et on renvoie vers /login
http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("auth");
      delete http.defaults.headers.common.Authorization;
      delete http.defaults.headers.common["x-codtiers"];
      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    }
    return Promise.reject(error);
  }
);

export default http;
